// extracted by mini-css-extract-plugin
module.exports = {"sk-chase":"Spinner_sk-chase__1STSy","sk-chase-dot":"Spinner_sk-chase-dot__1f_E_","sk-chase-dot-before":"Spinner_sk-chase-dot-before__1Ny8M"};